export class Drawer {
  private _name: string;
  private _props?: any;

  constructor(name: string, props?: any) {
    this._name = name;
    this._props = props || {};
  }

  get name(): string {
    return this._name;
  }

  get props(): any {
    return this._props;
  }
}
